<template>
  <component :is="component" />
</template>

<script>
import atmosphereBuyCheck from '../components/atmosphereBuyCheck.vue'
import atmosphereBuy from '../atmosphereBuy.vue'
export default {
  components: {
    atmosphereBuyCheck,
    atmosphereBuy
  },
  data() {
    return {
      component: 'atmosphereBuyCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'atmosphereBuyCheck' : 'atmosphereBuy'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order-manage/check/atmosphereBuyCheck.vue